/**
 * krypton API
 * Documentation of API endpoints of krypton
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SlipsSignedUrlRetrieve200Response {
    /**
    * Signed URL to download the report
    */
    'signedUrl'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "signedUrl",
            "baseName": "signed_url",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SlipsSignedUrlRetrieve200Response.attributeTypeMap;
    }

    public constructor() {
    }
}
